import { render, staticRenderFns } from "./RegisterOrganisation.vue?vue&type=template&id=4729c2b4"
import script from "./RegisterOrganisation.vue?vue&type=script&lang=js"
export * from "./RegisterOrganisation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports